// Tile dimensions (classic isometric diamond ratio 2:1)
export const TILE_WIDTH = 32;
export const TILE_HEIGHT = 16;

// Chunk = 16x16 tiles
export const CHUNK_SIZE = 16;

// How many chunks around the player to keep loaded
export const RENDER_DISTANCE = 3;

// Player
export const PLAYER_SPEED = 2; // tiles per second
export const PLAYER_FRAME_WIDTH = 200; // per frame in the walk spritesheet
export const PLAYER_FRAME_HEIGHT = 200; // per frame in the walk spritesheet
export const PLAYER_DISPLAY_SIZE = 56; // rendered size on screen
export const PLAYER_FRAMES_PER_DIR = 8; // walk frames per direction row
export const PLAYER_WALK_FRAMERATE = 10; // fps for walk animation

// Direction → spritesheet row mapping.
// The archer_walk.png has 8 rows (one per direction), 8 walk frames per row.
// Row order: N, NE, E, SE, S, SW, W, NW  (extracted from GM1 cols W,NW,N,NE,E,SE,S,SW)
export const DIR_ROW = {
  n:  4,
  ne: 5,
  e:  6,
  se: 7,
  s:  0,
  sw: 1,
  w:  2,
  nw: 3,
};

// World seed for deterministic procedural generation
export const WORLD_SEED = 42;

// Noise scale – smaller = smoother terrain variation
export const NOISE_SCALE = 0.08;

// Grass spritesheet
export const GRASS_SPRITE_COUNT = 20;
export const GRASS_FRAME_WIDTH = 250;
export const GRASS_FRAME_HEIGHT = 200;
// Display size – slightly larger than grid cell so tiles overlap naturally
// Ratio must match frame ratio (250:200 = 5:4) to avoid subpixel drift
export const GRASS_DISPLAY_WIDTH = 40;
export const GRASS_DISPLAY_HEIGHT = 32;

// Feature grass spritesheet (same frame layout as regular grass)
export const GRASS_FEATURE_SPRITE_COUNT = 20;
export const GRASS_FEATURE_CHANCE = 0.05; // 5% of tiles use a feature sprite

// Obstruction spritesheet (bushes, rocks – blocks movement)
export const GRASS_OBSTRUCTION_SPRITE_COUNT = 20;
export const GRASS_OBSTRUCTION_CHANCE = 0.005; // 0.5% of tiles are obstructed

// Patchy grass spritesheet (transition between grass and dirt)
export const GRASS_SPRITES_PATCHY_SPRITE_COUNT = 20;

// Dirt path spritesheet (same frame layout as grass)
export const DIRT_SPRITE_COUNT = 20;
export const DIRT_FEATURE_SPRITE_COUNT = 20;
export const DIRT_FEATURE_CHANCE = 0.10; // 10% of dirt tiles use a feature sprite
export const PATH_SPACING = 20;   // one path origin per 20×20 tile area

// Tree spritesheet (2x2 grid = 4 variants, 512x512 each)
export const TREE_SPRITE_COUNT = 4;
export const TREE_FRAME_WIDTH = 512;
export const TREE_FRAME_HEIGHT = 512;
export const TREE_CHANCE = 0.01; // 2% of valid 2x2 groups get a tree

// UI
export const UI_PADDING = 16;
export const INVENTORY_COLS = 5;
export const INVENTORY_ROWS = 4;
export const SLOT_SIZE = 56;
export const SLOT_GAP = 6;

// Equipment slot names
export const EQUIP_SLOTS = ['head', 'chest', 'legs', 'weapon', 'shield'];
